<template>
  <aside-flatkit 
    id="outlet-form" 
    width="w-xxl">

    <span slot="header-text">{{ outletExist() ? 'Edit' : 'Create' }} Outlet</span>

    <div 
      slot="body" 
      class="m-t-md">
      <form>
        <div class="col-sm-12">

          <div class="md-form-group">
            <input 
              v-model="outlet.name" 
              placeholder="Required" 
              data-parsley-required="true" 
              data-parsley-trigger="keyup change focusin" 
              class="md-input">
            <label>Name</label>
          </div>

          <!-- Location -->
          <div class="md-form-group">
            <vue-google-autocomplete
              id="glocation"
              ref="geoAutoComplete"
              :types="['geocode', 'establishment']"
              classname="md-input"
              label="Location"
              placeholder=""
              description="Type to search your location, address or company"
              @placechanged="setLocation"
            />
          </div>

          <div class="md-form-group m-t-md">
            <textarea
              v-model="outlet.address"
              class="md-input"/>
            <label>Address</label>
          </div>

          <div class="md-form-group">
            <input 
              v-model="outlet.latitude"
              data-parsley-type="number" 
              class="md-input">
            <label>Latitude</label>
          </div>

          <div class="md-form-group">
            <input 
              v-model="outlet.longitude"
              data-parsley-type="number" 
              class="md-input">
            <label>Longitude</label>
          </div>

        </div>
      </form>
    </div>
    <button 
      slot="footer" 
      :disabled="loading" 
      class="md-btn md-raised m-b-sm w-xs green" 
      @click="submit">Save</button>
  </aside-flatkit>
</template>

<script>
var parsley = require('parsleyjs');
import { Event } from '../../event-bus';

export default {
    props: {
        outlet: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
        };
    },
    watch: {
        outlet() {
            $('#outlet-form form')
                .parsley()
                .reset();
        },
    },

    methods: {
        outletExist() {
            return this.outlet.id != null;
        },

        getSubmittedValue() {
            return {
                name: this.outlet.name,
                address: this.outlet.address,
                latitude: this.outlet.latitude,
                longitude: this.outlet.longitude,
            };
        },

        submit() {
            var that = this;

            if (this.validateForm()) {
                this.loading = true;

                axios[this.getSubmitMethod()](
                    this.getSubmitApi(),
                    this.getSubmittedValue(),
                ).then(
                    function(res) {
                        that.loading = false;

                        if (that.outletExist()) {
                            $('#outlet-form').modal('hide');
                        }

                        let msg =
                            'Outlet has successfully ' +
                            (!that.outletExist() ? 'created' : 'updated');

                        toastr.success(msg);
                        Event.$emit('outletChanged');
                    },
                    err => {
                        that.loading = false;
                    },
                );
            }
        },

        getSubmitMethod() {
            if (this.outletExist()) {
                return 'patch';
            } else {
                return 'post';
            }
        },

        setLocation: function(addr) {
            this.outlet.address = addr.formatted_address;
            this.outlet.latitude = addr.latitude;
            this.outlet.longitude = addr.longitude;
        },

        getSubmitApi() {
            if (this.outletExist()) {
                return Laroute.route('outlets.update', { id: this.outlet.id });
            } else {
                return Laroute.route('outlets.create');
            }
        },

        validateForm() {
            let form = $('#outlet-form form').parsley();
            form.validate();

            return form.isValid();
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/outlet/outlet-form.vue